﻿const root = document.querySelector("[data-partner-selections-root]");
const container = document.querySelector("[data-partner-selections-list]");
const emptyState = document.querySelector("[data-partner-selections-empty]");
const loadingState = document.querySelector("[data-partner-selections-loading]");
const errorState = document.querySelector("[data-partner-selections-error]");

const DEFAULT_LOAD_ERROR = "Impossible de charger vos s\u00e9lections pour le moment.";
const DEFAULT_UPDATE_ERROR = "Impossible de mettre \u00e0 jour cette ligne.";
const ACTION_MODAL_ID = "partner-selections-action-modal";

function toggle(el, visible) {
  if (!el) return;
  el.classList.toggle("hidden", !visible);
}

function labelStatus(status) {
  if (status === "sent_to_partner") return "Envoy\u00e9e au partenaire";
  if (status === "return_requested") return "Retour demand\u00e9";
  if (status === "returned_by_partner_customer") return "Retour client (paire gard\u00e9e)";
  if (status === "return_to_trolet_requested") return "Retour client \u00e0 reprendre par Trolet";
  if (status === "returned_damaged") return "Retourn\u00e9e (non revendable)";
  if (status === "sold_by_partner") return "Vendue";
  if (status === "cancelled_by_partner") return "Annul\u00e9e";
  if (status === "picked_up_by_trolet") return "R\u00e9cup\u00e9r\u00e9e par Trolet";
  return "S\u00e9lectionn\u00e9e";
}

function getProductUrl(line) {
  const rawUrl = String(line.product_url || "").trim();
  if (!rawUrl) return "";

  try {
    const url = new URL(rawUrl, window.location.origin);
    if (url.origin !== window.location.origin) return "";
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return "";
  }
}

function createLineProduct(line) {
  const product = document.createElement("div");
  product.className = "partner-selections__product";

  const productUrl = getProductUrl(line);
  const imageUrl = String(line.image_url || "").trim();
  let media;

  if (imageUrl) {
    const image = document.createElement("img");
    image.className = "partner-selections__thumbnail";
    image.src = imageUrl;
    image.alt = "";
    image.loading = "lazy";
    image.width = 80;
    image.height = 80;
    media = image;
  } else {
    media = document.createElement("span");
    media.className = "partner-selections__thumbnail partner-selections__thumbnail--placeholder";
    media.setAttribute("aria-hidden", "true");
  }

  if (productUrl) {
    const mediaLink = document.createElement("a");
    mediaLink.className = "partner-selections__thumbnail-link";
    mediaLink.href = productUrl;
    mediaLink.tabIndex = -1;
    mediaLink.setAttribute("aria-hidden", "true");
    mediaLink.append(media);
    product.append(mediaLink);
  } else {
    product.append(media);
  }

  const details = document.createElement("div");
  details.className = "partner-selections__product-details";

  const title = document.createElement(productUrl ? "a" : "span");
  title.className = "partner-selections__product-title";
  title.textContent = line.product_title || "Produit";
  if (productUrl) title.href = productUrl;

  const meta = document.createElement("span");
  meta.className = "partner-selections__line-text";
  const variant = line.variant_title && line.variant_title !== "Default Title" ? line.variant_title : "";
  meta.textContent = variant ? `${variant} | Qt\u00e9: ${line.quantity || 0}` : `Qt\u00e9: ${line.quantity || 0}`;

  details.append(title, meta);
  product.append(details);
  return product;
}

function ensureActionModal() {
  let modal = document.getElementById(ACTION_MODAL_ID);
  if (modal) return modal;

  modal = document.createElement("div");
  modal.id = ACTION_MODAL_ID;
  modal.style.position = "fixed";
  modal.style.inset = "0";
  modal.style.zIndex = "9999";
  modal.style.display = "none";
  modal.style.placeItems = "center";
  modal.style.background = "rgba(0, 0, 0, 0.45)";
  modal.innerHTML = `
    <div role="dialog" aria-modal="true" style="position:relative;background:#fff;color:#111;width:min(560px,92vw);padding:20px;border-radius:12px;box-shadow:0 20px 50px rgba(0,0,0,.3);">
      <button type="button" data-close aria-label="Fermer" style="position:absolute;top:8px;right:8px;border:0;background:transparent;font-size:22px;line-height:1;cursor:pointer;padding:6px;">×</button>
      <h3 data-modal-title style="margin:0 0 12px 0;font-size:1.1rem;">Mise a jour du statut</h3>
      <label data-reason-wrap style="display:block;margin:0 0 10px 0;">
        <span style="display:block;margin-bottom:6px;">Motif client (obligatoire)</span>
        <textarea data-reason rows="3" style="width:100%;border:1px solid #d1d5db;border-radius:8px;padding:8px;"></textarea>
      </label>
      <label data-condition-wrap style="display:none;margin:0 0 10px 0;">
        <span style="display:block;margin-bottom:6px;">État de la chaussure (Abimée, Impécable, Sale...)</span>
        <input data-condition type="text" style="width:100%;border:1px solid #d1d5db;border-radius:8px;padding:8px;" />
      </label>
      <label data-resellable-wrap style="display:none;margin:0 0 10px 0;align-items:center;gap:8px;">
        <input data-resellable type="checkbox" checked />
        <span>La chaussure est revendable</span>
      </label>
      <p data-error style="display:none;color:#b91c1c;margin:0 0 10px 0;font-size:.92rem;"></p>
      <div style="display:flex;justify-content:flex-end;gap:8px;">
        <button type="button" data-cancel class="button button-secondary">Annuler</button>
        <button type="button" data-submit class="button">Valider</button>
      </div>
    </div>
  `;
  document.body.appendChild(modal);
  return modal;
}

function askActionPayload({ title, requireReason, initialReason, promptReturnCondition }) {
  const modal = ensureActionModal();
  const titleEl = modal.querySelector("[data-modal-title]");
  const reasonWrap = modal.querySelector("[data-reason-wrap]");
  const reasonInput = modal.querySelector("[data-reason]");
  const conditionWrap = modal.querySelector("[data-condition-wrap]");
  const conditionInput = modal.querySelector("[data-condition]");
  const resellableWrap = modal.querySelector("[data-resellable-wrap]");
  const resellableInput = modal.querySelector("[data-resellable]");
  const errorEl = modal.querySelector("[data-error]");
  const closeButton = modal.querySelector("[data-close]");
  const cancelButton = modal.querySelector("[data-cancel]");
  const submitButton = modal.querySelector("[data-submit]");

  titleEl.textContent = title || "Mise a jour du statut";
  reasonWrap.style.display = requireReason ? "block" : "none";
  conditionWrap.style.display = promptReturnCondition ? "block" : "none";
  resellableWrap.style.display = promptReturnCondition ? "flex" : "none";
  reasonInput.value = initialReason || "";
  conditionInput.value = "";
  resellableInput.checked = true;
  errorEl.style.display = "none";
  errorEl.textContent = "";
  modal.style.display = "grid";

  return new Promise((resolve) => {
    const close = (result) => {
      closeButton.removeEventListener("click", onCancel);
      cancelButton.removeEventListener("click", onCancel);
      submitButton.removeEventListener("click", onSubmit);
      modal.style.display = "none";
      resolve(result);
    };

    const onCancel = () => close(null);
    const onSubmit = () => {
      const reason = String(reasonInput.value || "").trim();
      if (requireReason && !reason) {
        errorEl.textContent = "Le motif est obligatoire.";
        errorEl.style.display = "block";
        reasonInput.focus();
        return;
      }
      close({
        reason,
        returnCondition: String(conditionInput.value || "").trim(),
        isResellable: !!resellableInput.checked,
      });
    };

    closeButton.addEventListener("click", onCancel);
    cancelButton.addEventListener("click", onCancel);
    submitButton.addEventListener("click", onSubmit);
    if (requireReason) {
      reasonInput.focus();
    } else if (promptReturnCondition) {
      conditionInput.focus();
    } else {
      submitButton.focus();
    }
  });
}

function createLineActions(line, statusEndpoint) {
  const actions = document.createElement("div");
  actions.className = "partner-selections__actions";

  if (line.status === "sold_by_partner" || line.status === "returned_by_partner_customer") {
    if (line.status === "sold_by_partner") {
      const keepButton = document.createElement("button");
      keepButton.type = "button";
      keepButton.className = "button";
      keepButton.textContent = "Retour client (je garde)";
      keepButton.dataset.lineId = line.line_id;
      keepButton.dataset.nextStatus = "returned_by_partner_customer";
      keepButton.dataset.statusEndpoint = statusEndpoint;
      keepButton.dataset.requireReason = "true";
      keepButton.dataset.promptReturnCondition = "true";
      actions.append(keepButton);
    }

    const pickupButton = document.createElement("button");
    pickupButton.type = "button";
    pickupButton.className = "button button-secondary";
    pickupButton.textContent = "Demander reprise Trolet";
    pickupButton.dataset.lineId = line.line_id;
    pickupButton.dataset.nextStatus = "return_to_trolet_requested";
    pickupButton.dataset.statusEndpoint = statusEndpoint;
    pickupButton.dataset.requireReason = "true";
    pickupButton.dataset.reason = "retour client - reprise demand\u00e9e par Trolet";
    actions.append(pickupButton);

    if (line.status === "returned_by_partner_customer") {
      const soldAgainButton = document.createElement("button");
      soldAgainButton.type = "button";
      soldAgainButton.className = "button button-secondary";
      soldAgainButton.textContent = "Revendue";
      soldAgainButton.dataset.lineId = line.line_id;
      soldAgainButton.dataset.nextStatus = "sold_by_partner";
      soldAgainButton.dataset.statusEndpoint = statusEndpoint;
      soldAgainButton.dataset.reason = "paire revendue apr\u00e8s retour client";
      actions.append(soldAgainButton);
    }

    return actions;
  }

  if (line.status !== "selected" && line.status !== "sent_to_partner") return actions;

  const soldButton = document.createElement("button");
  soldButton.type = "button";
  soldButton.className = "button";
  soldButton.textContent = "Marquer vendue";
  soldButton.dataset.lineId = line.line_id;
  soldButton.dataset.nextStatus = "sold_by_partner";
  soldButton.dataset.statusEndpoint = statusEndpoint;

  const cancelButton = document.createElement("button");
  cancelButton.type = "button";
  cancelButton.className = "button button-secondary";
  cancelButton.textContent = line.status === "sent_to_partner" ? "Demander retour" : "Annuler";
  cancelButton.dataset.lineId = line.line_id;
  cancelButton.dataset.nextStatus = line.status === "sent_to_partner" ? "return_requested" : "cancelled_by_partner";
  cancelButton.dataset.statusEndpoint = statusEndpoint;
  cancelButton.dataset.reason =
    line.status === "sent_to_partner"
      ? "demande de retour depuis compte partenaire"
      : "annulation depuis compte partenaire";

  actions.append(soldButton, cancelButton);
  return actions;
}

function renderSelections(selections, statusEndpoint) {
  container.innerHTML = "";

  for (const selection of selections) {
    const card = document.createElement("article");
    card.className = "partner-selections__card";

    const date = selection.created_at
      ? new Date(selection.created_at).toLocaleString("fr-CA")
      : "Date inconnue";
    const title = document.createElement("h3");
    title.className = "partner-selections__card-title";
    title.textContent = selection.selection_ref
      ? `S\u00e9lection ${selection.selection_ref} \u2022 ${date}`
      : `S\u00e9lection envoy\u00e9e le ${date}`;

    const meta = document.createElement("p");
    meta.className = "partner-selections__card-meta";
    meta.textContent = `${selection.lines?.length || 0} article(s)`;

    const list = document.createElement("ul");
    list.className = "partner-selections__items";

    for (const line of selection.lines || []) {
      const li = document.createElement("li");
      li.className = "partner-selections__line";

      const main = document.createElement("div");
      main.className = "partner-selections__line-main";

      const status = document.createElement("span");
      status.className = `partner-selections__status partner-selections__status--${line.status || "selected"}`;
      status.textContent = labelStatus(line.status);

      main.append(createLineProduct(line), status);
      li.append(main, createLineActions(line, statusEndpoint));
      list.appendChild(li);
    }

    card.append(title, meta, list);
    container.appendChild(card);
  }
}

async function fetchSelections(listEndpoint) {
  const response = await fetch(listEndpoint, {
    method: "GET",
    credentials: "same-origin",
    headers: { Accept: "application/json" },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok || !body?.ok) {
    throw new Error(body?.error || DEFAULT_LOAD_ERROR);
  }
  return Array.isArray(body.selections) ? body.selections : [];
}

async function updateLineStatus(lineId, toStatus, statusEndpoint, reason, returnCondition, isResellable) {
  const response = await fetch(statusEndpoint, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      line_id: lineId,
      to_status: toStatus,
      reason: reason || "mise \u00e0 jour depuis compte partenaire",
      return_condition: returnCondition || "",
      is_resellable: typeof isResellable === "boolean" ? isResellable : undefined,
    }),
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok || !body?.ok) {
    throw new Error(body?.error || DEFAULT_UPDATE_ERROR);
  }
}

async function init() {
  if (!root || !container) return;

  const listEndpoint = root.dataset.listEndpoint || "/apps/partner-selection/selections";
  const statusEndpoint = root.dataset.statusEndpoint || "/apps/partner-selection/line-status";

  toggle(loadingState, true);
  toggle(errorState, false);
  toggle(emptyState, false);

  try {
    const selections = await fetchSelections(listEndpoint);
    if (selections.length === 0) {
      toggle(emptyState, true);
      container.innerHTML = "";
    } else {
      renderSelections(selections, statusEndpoint);
    }
  } catch (error) {
    if (errorState) {
      errorState.textContent = error instanceof Error ? error.message : DEFAULT_LOAD_ERROR;
    }
    toggle(errorState, true);
  } finally {
    toggle(loadingState, false);
  }
}

document.addEventListener("click", async (event) => {
  const rawTarget = event.target;
  if (!(rawTarget instanceof Element)) return;
  const target = rawTarget.closest("button");
  if (!(target instanceof HTMLButtonElement)) return;
  if (!target.dataset.lineId || !target.dataset.nextStatus || !target.dataset.statusEndpoint) return;

  event.preventDefault();
  const originalLabel = target.textContent;
  let reason = target.dataset.reason || "";
  let returnCondition = "";
  let isResellable;

  if (target.dataset.requireReason === "true" || target.dataset.promptReturnCondition === "true") {
    const payload = await askActionPayload({
      title: target.dataset.nextStatus === "returned_by_partner_customer" ? "Retour client (je garde)" : "Mise a jour du statut",
      requireReason: target.dataset.requireReason === "true",
      initialReason: reason,
      promptReturnCondition: target.dataset.promptReturnCondition === "true",
    });
    if (!payload) return;
    reason = payload.reason || reason;
    returnCondition = payload.returnCondition || "";
    isResellable = payload.isResellable;
  }

  target.disabled = true;
  target.textContent = "Mise \u00e0 jour...";

  try {
    await updateLineStatus(
      target.dataset.lineId,
      target.dataset.nextStatus,
      target.dataset.statusEndpoint,
      reason,
      returnCondition,
      isResellable
    );
    await init();
  } catch (error) {
    if (errorState) {
      errorState.textContent = error instanceof Error ? error.message : DEFAULT_UPDATE_ERROR;
    }
    toggle(errorState, true);
  } finally {
    target.disabled = false;
    target.textContent = originalLabel || "Action";
  }
});

init();
